import { useCallback, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'

import { Modal } from 'Components'
import { CrossIcon, SearchIcon } from 'Icons'

import type { WheelItem, WheelItemsData } from './wheelData'
import { FeelingBadge } from './WheelDescription'

type MobileSearchDialogProps = {
  wheelItemsData: WheelItemsData
  itemOnSelect: (item: WheelItem) => void
  isOpen: boolean
  onClose: () => void
}

export default function MobileSearchDialog({
  wheelItemsData,
  itemOnSelect,
  isOpen,
  onClose,
}: MobileSearchDialogProps) {
  const intl = useIntl()
  const [searchText, setSearchText] = useState<string>('')

  const searchPlaceholder = intl.formatMessage({ id: 'input.search', defaultMessage: 'Search' })

  const onResetButtonClick = useCallback(() => {
    setSearchText('')
  }, [])

  const filteredItems = useMemo(
    () =>
      Object.entries(wheelItemsData).filter(([_, { label }]) =>
        label.label.toLowerCase().includes(searchText.toLowerCase()),
      ),
    [wheelItemsData, searchText],
  )

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="menu-title">
        <label className="input input-sm font-base max-w-full">
          <SearchIcon />
          <input
            placeholder={searchPlaceholder}
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <button
            className="cursor-pointer opacity-50 transition-opacity enabled:hover:opacity-100"
            disabled={!searchText}
            onClick={onResetButtonClick}
          >
            <CrossIcon />
          </button>
        </label>
      </div>
      <ul className="menu w-full flex-nowrap overflow-scroll">
        {filteredItems.map(([key, { label: labelItem }]) => (
          <li key={key}>
            <a className="text-base" onClick={() => itemOnSelect(key as WheelItem)}>
              <FeelingBadge
                className="h-3 w-3"
                item={key as WheelItem}
                wheelItemsData={wheelItemsData}
              />
              {labelItem.label}
            </a>
          </li>
        ))}
      </ul>
    </Modal>
  )
}
